module.exports = __webpack_public_path__ + "img/symbol_4.57f772ec.png";